import { DROP_LAYOUT_EL, DROP_CONTAINER_ACTIVE_CLASSNAME, MIN_SCALE_SIZE } from '../../../json-parse/src/tools/const'
import { containerMethods, contextmenuBlock } from '../utils/quickBar'
import UEI from '../use/useEditInfo'
import { IStyleConfig } from 'packages/json-parse/src/interface'

// 鼠标拖动元素逻辑开始---------------------------------------------------------------------------
export const mouseMethods = {
  isMoving: false, // 拖动元素是否处于拖动状态
  doMoving: false, // 是否执行移动行为
  isScale: false, // 是否处于缩放状态
  scaleWrap: undefined, // 缩放对象容器
  scaleTarget: undefined, // 缩放对象
  /*点击鼠标右键*/
  onContextmenuBlock: (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    // 重新计算元素和布局信息，生成菜单
    if (e.target) mouseMethods.dragedClick(e)
    if (UEI.clickElement) contextmenuBlock(e)
  },
  // 点击了容器, 计算元素和布局信息
  dragedClick(event: any, mousedown = false) {
    if (mousedown) {
      // 鼠标按下
      if (UEI.clickElement && UEI.state.clickLayout) {
        UEI.clickElement && (UEI.clickElement as any).classList.remove(DROP_CONTAINER_ACTIVE_CLASSNAME.moving)
        UEI.setClickElement(undefined)
        UEI.setClickLayout(undefined)
      }
      const tempElement: HTMLElement | undefined = containerMethods.findUserfulParent(event.target, true)
      const tempLayout = tempElement && (tempElement as any)[DROP_LAYOUT_EL]
      if (!tempElement || !tempLayout) return
      UEI.setClickElement(tempElement)
      UEI.setClickLayout(tempLayout)
    }
    if (UEI.clickElement && UEI.state.clickLayout) {
      UEI.clickElement && (UEI.clickElement as any).classList.add(DROP_CONTAINER_ACTIVE_CLASSNAME.moving)
      UEI.setDotrectInfo()
    }
  },
  handleSetMouseLocation(event: any) {
    if(!UEI.state.clickLayout) return
    const styleConfig = UEI.state.clickLayout.styleConfig
    styleConfig &&
      UEI.setMouseLocation({
        originTop: styleConfig.top || 0,
        originLeft: (styleConfig.left as number) || 0,
        downTop: event.y,
        downLeft: event.x
      })
  },
  mouseDown(event: any) {
    mouseMethods.doMoving = false
    if (!mouseMethods.scaleWrap || (mouseMethods.scaleWrap && !(mouseMethods.scaleWrap as any).contains(event.target))) {
      mouseMethods.scaleWrap = document.querySelector('.scale-rect') as any
    }
    if (mouseMethods.scaleWrap && (mouseMethods.scaleWrap as any).contains(event.target)) {
      mouseMethods.scaleTarget = event.target
      if (UEI.clickElement && UEI.state.clickLayout) {
        UEI.clickElement && (UEI.clickElement as any).classList.add(DROP_CONTAINER_ACTIVE_CLASSNAME.moving)
        mouseMethods.handleSetMouseLocation(event)
      }
    } else {
      mouseMethods.scaleTarget = undefined
      mouseMethods.dragedClick(event, true)
      if (UEI.clickElement && UEI.state.clickLayout) {
        if ([true, 'true'].includes((UEI.state.clickLayout as any).isfixed)) return
        // 相对定位不能移动???
        // if (containerMethods.elementIsRelative(UEI.clickElement)) return
        mouseMethods.isMoving = true
        mouseMethods.handleSetMouseLocation(event)
        UEI.setDotrectInfo()
        // 开始计算所有元素的坐标x/y轴辅助线信息
        mouseMethods.getLineArrInfo(event)
      } else {
        console.info('mousedown在祖先元素中没有找到目标元素')
      }
    }
  },
  mouseMove(event: any) {
    if (mouseMethods.scaleTarget) {
      // 四周缩放点相关
      mouseMethods.handleScaleing(event)
    } else {
      if (!mouseMethods.doMoving && UEI.state.mouseLocation) {
        // 为了防止鼠标按下时的抖动
        let tempTop = event.y - UEI.state.mouseLocation.downTop
        let tempLeft = event.x - UEI.state.mouseLocation.downLeft
        if (!(Math.abs(tempTop) < 5 && Math.abs(tempLeft) < 5)) {
          mouseMethods.doMoving = true
        }
      }
      if (!mouseMethods.isMoving) return
      if (mouseMethods.isMoving && UEI.clickElement && UEI.state.clickLayout && event) {
        if (UEI.state.clickLayout?.isroot) return // 根元素无法移动
        if ([true, 'true'].includes(UEI.state.clickLayout.isfixed as any)) return
        // 改变位置
        if (UEI.state.clickLayout && UEI.state.clickLayout.styleConfig && UEI.state.mouseLocation && mouseMethods.doMoving) {
          let tempTop = event.y - UEI.state.mouseLocation.downTop
          let tempLeft = event.x - UEI.state.mouseLocation.downLeft
          ;(UEI.clickElement as any).style.transform = `translate3d(${tempLeft}px, ${tempTop}px, 0)`
          UEI.setDotrectInfo()
        }
      }
    }
  },
  mouseUp(event: any) {
    mouseMethods.isMoving = false
    if (mouseMethods.scaleTarget) {
      // 四周缩放点相关
      mouseMethods.scaleTarget = undefined
    } else {
      if (UEI.clickElement && UEI.state.clickLayout) {
        if (UEI.state.clickLayout.isroot) return // 根元素无法移动
        if ([true, 'true'].includes((UEI.state.clickLayout as any).isfixed)) return
        if (UEI.state.clickLayout.styleConfig) {
          ;(UEI.clickElement as any).style.transform = ''
          if (UEI.state.mouseLocation && mouseMethods.doMoving) {
            let tempTop = parseInt(UEI.state.mouseLocation.originTop + '') + (event.y - UEI.state.mouseLocation.downTop)
            let tempLeft = parseInt(UEI.state.mouseLocation.originLeft + '') + (event.x - UEI.state.mouseLocation.downLeft)
            UEI.state.clickLayout.styleConfig.top = parseInt(tempTop + '')
            UEI.state.clickLayout.styleConfig.left = parseInt(tempLeft + '')    
            // 根据辅助线修正目标的位置
            mouseMethods.modifyLocationByHelpLine()
          }
        }
        // 删除辅助线
        setTimeout(() => UEI.deleteHelpLine() )
      }
    }
  },
  // 根据辅助线修正目标的位置
  modifyLocationByHelpLine() {
    if (!UEI.state.dotrectInfo) return
    if (!(UEI.state.clickLayout && UEI.state.clickLayout.styleConfig)) return
    const xArr = UEI.state.lineObjInfo.x.filter(item => item !== '')
    const yArr = UEI.state.lineObjInfo.y.filter(item => item !== '')
    let xModify = 0
    let yModify = 0
    for (let i = 0; i < xArr.length; i++) {
      const element = xArr[i]
      if (typeof element !== 'number') continue
      if (i === 0) {
        xModify = element - (UEI.state.dotrectInfo as any).left
      } else if (i === 1) {
        xModify = element - (UEI.state.dotrectInfo as any).left - (UEI.state.dotrectInfo as any).width / 2
      } else if (i === 2) {
        xModify = element - (UEI.state.dotrectInfo as any).left - (UEI.state.dotrectInfo as any).width
      }
    }
    for (let i = 0; i < yArr.length; i++) {
      const element = yArr[i]
      if (typeof element !== 'number') continue
      if (i === 0) {
        yModify = element - (UEI.state.dotrectInfo as any).top
      } else if (i === 1) {
        yModify = element - (UEI.state.dotrectInfo as any).top - (UEI.state.dotrectInfo as any).height / 2
      } else if (i === 2) {
        yModify = element - (UEI.state.dotrectInfo as any).top - (UEI.state.dotrectInfo as any).height
      }
    }
    UEI.state.clickLayout.styleConfig.left = parseInt((UEI.state.clickLayout.styleConfig as any).left + xModify)
    UEI.state.clickLayout.styleConfig.top = parseInt(UEI.state.clickLayout.styleConfig.top + yModify)
  },
  // 执行缩放操作
  handleScaleing(event: any) {
    if (!(UEI.state.clickLayout && UEI.state.clickLayout.styleConfig && UEI.state.mouseLocation)) return
    const tempHeight = event.y - UEI.state.mouseLocation.downTop
    const tempWidth = event.x - UEI.state.mouseLocation.downLeft
    const classArray: string[] = Array.from((mouseMethods.scaleTarget as any).classList)
    const styleConfig = UEI.state.clickLayout.styleConfig
    if (!styleConfig) return
    const width = parseFloat(styleConfig.width as any) || MIN_SCALE_SIZE
    const height = parseFloat(styleConfig.height as any) || MIN_SCALE_SIZE
    const left = parseFloat(styleConfig.left as any) || MIN_SCALE_SIZE
    const top = parseFloat(styleConfig.top as any) || MIN_SCALE_SIZE
    if (classArray.includes('dot-center-right')) {
      // 右侧
      const resWidth = width + tempWidth
      styleConfig.width = resWidth < MIN_SCALE_SIZE ? MIN_SCALE_SIZE : resWidth
    } else if (classArray.includes('dot-center-left')) {
      // 左侧
      const resWidth = width - tempWidth
      const resLeft = left + tempWidth
      if (resWidth >= MIN_SCALE_SIZE) {
        styleConfig.width = resWidth
        styleConfig.left = resLeft
      }
    } else if (classArray.includes('dot-center-bottom')) {
      // 底部
      const resHeight = height + tempHeight
      styleConfig.height = resHeight < MIN_SCALE_SIZE ? MIN_SCALE_SIZE : resHeight
    } else if (classArray.includes('dot-center-top')) {
      // 上面
      const resHeight = height - tempHeight
      const resTop = top + tempHeight
      if (resHeight >= MIN_SCALE_SIZE) {
        styleConfig.height = resHeight
        styleConfig.top = resTop
      }
    } else if (classArray.includes('dot-top-left')) {
      // 左上角
      const resHeight = height - tempHeight
      const resTop = top + tempHeight
      const resWidth = width - tempWidth
      const resLeft = left + tempWidth
      if (resHeight >= MIN_SCALE_SIZE) {
        styleConfig.height = resHeight
        styleConfig.top = resTop
      }
      if (resWidth >= MIN_SCALE_SIZE) {
        styleConfig.width = resWidth
        styleConfig.left = resLeft
      }
    } else if (classArray.includes('dot-top-right')) {
      // 右上角
      const resHeight = height - tempHeight
      const resTop = top + tempHeight
      const resWidth = width + tempWidth
      if (resHeight >= MIN_SCALE_SIZE) {
        styleConfig.height = resHeight
        styleConfig.top = resTop
      }
      if (resWidth >= MIN_SCALE_SIZE) styleConfig.width = resWidth
    } else if (classArray.includes('dot-bottom-right')) {
      // 右下角
      const resHeight = height + tempHeight
      const resWidth = width + tempWidth
      if (resHeight >= MIN_SCALE_SIZE) styleConfig.height = resHeight
      if (resWidth >= MIN_SCALE_SIZE) styleConfig.width = resWidth
    } else if (classArray.includes('dot-bottom-left')) {
      // 左下角
      const resHeight = height + tempHeight
      const resWidth = width - tempWidth
      const resLeft = left + tempWidth
      if (resHeight >= MIN_SCALE_SIZE) styleConfig.height = resHeight
      if (resWidth >= MIN_SCALE_SIZE) {
        styleConfig.width = resWidth
        styleConfig.left = resLeft
      }
    }
    // 更新数据
    UEI.setMouseLocation({
      originTop: styleConfig.top || 0,
      originLeft: (styleConfig.left as number) || 0,
      downTop: event.y,
      downLeft: event.x
    })
  },
  // 计算x轴和y轴的辅助线信息
  getLineArrInfo(event: any) {
    let allContainerList = document.querySelectorAll('[iscontainer]')
    let xlineArr: number[] = []
    let ylineArr: number[] = []
    for (let i = 0; i < allContainerList.length; i++) {
      const element = allContainerList[i]
      // if(element.getAttribute('isroot') === 'true') continue
      if (element.className.includes(DROP_CONTAINER_ACTIVE_CLASSNAME.moving)) continue
      const boundingInfo = element.getBoundingClientRect()
      xlineArr.push(boundingInfo.left, boundingInfo.left + boundingInfo.width, boundingInfo.left + boundingInfo.width / 2)
      ylineArr.push(boundingInfo.top, boundingInfo.top + boundingInfo.height, boundingInfo.top + boundingInfo.height / 2)
    }
    xlineArr = Array.from(new Set(xlineArr.sort((a, b) => a - b)))
    ylineArr = Array.from(new Set(ylineArr.sort((a, b) => a - b)))    
    UEI.setLineArrInfo({ x: xlineArr, y: ylineArr })
  }
}
